module.exports = __webpack_public_path__ + "img/icon7.2617e045.png";